
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CompMeta from '../../meta/LowCodeComponents/BillHead';
import { Affix } from '@platform/base';
import "./index.less";

/**
 * @class NCBillHead
 * @column 1
 * @compType 1
 * @canAppend false
 * @path LowCodeComponents.NCBillHead
 * @label 标题
 *
 */
class NCBillHead extends Component {
    constructor(props) {
        super(props);
    }
    static propTypes = {
        /**
        * @title 区域编码
        * @description 组件标识
        */
        moduleId: PropTypes.string.isRequired,
        /**
         * @title 标题
         * @description 标题
         */
        title: PropTypes.string,
        /**
         * @title 单号
         * @description 单号
         */
        billCode: PropTypes.string,
        /**
        * @title 显示后退按钮
        * @description 显示后退按钮
        */
        initShowBackBtn: PropTypes.bool,
        /**
         * @title 显示分页
         * @description 显示分页
         */
        showPagination: PropTypes.bool,
        /**
        * @title 显示刷新
        * @description 显示刷新
        */
        showRefresh: PropTypes.bool,
        /**
        * @title url主键名称
        * @description url主键名称
        */
        urlPkname: PropTypes.string,
        /**
        * @title 缓存code
        * @description 缓存code
        */
        leftArea: PropTypes.node,
        /**
        * @title url主键名称
        * @description url主键名称
        */
        rightArea: PropTypes.node,
        /**
         * @title 是否可见
         * @description 是否可见
         */
        visible: PropTypes.bool,

    }
    static getCompMeta() {
        return CompMeta;
    }

    //渲染刷新按钮
    renderRefresh = () => {
        let { onClick } = this.props;
        const item = {
            key: 'refresh',
            type: 'general_btn'
        }
        return (
            <HelperTip
                delayShow={500}
            >
                <Button
                    disabled={item.disabled}
                    className={
                        item.btncolor == 'button_main' ? 'button-primary refresh-component' : 'refresh-component'
                    }
                    onClick={() => {
                        onClick && onClick({
                            key: 'refresh',
                            title: '',
                            item,
                        })
                    }
                    }
                    fieldid='refresh'
                    btn-code='refresh'
                >
                    <i className="iconfont icon-shuaxin1" />
                </Button>
            </HelperTip>
        );
    }

    //渲染分页按钮
    renderPagination = () => {
        const { dataSource, urlPkname, cardPagination, config = {}, handlePageInfoChange } = this.props;
        const { createCardPagination } = cardPagination;
        return <div className="header-cardPagination-area" style={{ float: 'right' }}>
            {createCardPagination({
                dataSource,
                urlPkname,
                handlePageInfoChange,
                ...config
            })}
        </div>
    }

    render() {
        const {
            BillHeadInfo,
            title,
            billCode,
            initShowBackBtn,
            showPagination,
            showRefresh,
            backBtnClick,
            config = {}
        } = this.props;
        const { createBillHeadInfo } = BillHeadInfo;
        return (
            <Affix offsetTop={0}>
                <div className="nc-bill-header-area">
                    {/* 标题区域 */}
                    <div className="header-title-search-area">
                        {createBillHeadInfo({
                            title,
                            billCode,
                            initShowBackBtn,
                            backBtnClick,
                            ...config
                        })}
                    </div>
                    <div className="header-center">
                        {/* 自定义区域 */}
                        <div className="header-custom-area">
                            {this.props.leftArea}
                        </div>
                        {/* 按钮组区域 */}
                        <div className="header-button-area">
                            {this.props.rightArea}
                        </div>
                    </div>
                    <div className="header-right-btns">
                        {/* 刷新按钮 */}
                        {showRefresh && this.renderRefresh()}
                        {/* 分页按钮 */}
                        {showPagination && this.renderPagination()}
                    </div>

                </div>
            </Affix>
        )
    }
}

export default NCBillHead;
